export default __webpack_public_path__ + "static/media/yellow_crown.ab37010e.svg";